import { defineMessages } from 'react-intl';

const SOCCER = defineMessages({
  ball_possession: {
    id: 'teamstats.soccer.ball_possession',
    defaultMessage: 'Possession',
  },
  formation: {
    id: 'teamstats.soccer.formation',
    defaultMessage: 'Formation',
  },
  shots_on_goal: {
    id: 'teamstats.soccer.shots_on_goal',
    defaultMessage: 'Shots On Goal',
  },
  corner_kicks: {
    id: 'teamstats.soccer.corner_kicks',
    defaultMessage: 'Corner Kicks',
  },
  crosses: {
    id: 'teamstats.soccer.crosses',
    defaultMessage: 'Crosses',
  },
  fouls: {
    id: 'teamstats.soccer.fouls',
    defaultMessage: 'Fouls',
  },
  yellow_cards: {
    id: 'teamstats.soccer.yellow_cards',
    defaultMessage: 'Yellow Cards',
  },
  red_cards: {
    id: 'teamstats.soccer.red_cards',
    defaultMessage: 'Red Cards',
  },
  offsides: {
    id: 'teamstats.soccer.offsides',
    defaultMessage: 'Offsides',
  },
  assists: {
    id: 'teamstats.soccer.assists',
    defaultMessage: 'Assists',
  },
});

const BASEBALL = defineMessages({
  runs_per_game: {
    id: 'teamstats.baseball.runs_per_game',
    defaultMessage: 'Runs',
  },
  runs_against_per_game: {
    id: 'teamstats.baseball.runs_against_per_game',
    defaultMessage: 'Runs Allowed',
  },
  hits_per_game: {
    id: 'teamstats.baseball.hits_per_game',
    defaultMessage: 'Hits',
  },
  hits_against_per_game: {
    id: 'teamstats.baseball.hits_against_per_game',
    defaultMessage: 'Hits Allowed',
  },
  // batting
  batting_average: {
    id: 'teamstats.baseball.batting_average',
    defaultMessage: 'AVG',
  },
  on_base_percentage: {
    id: 'teamstats.baseball.on_base_percentage',
    defaultMessage: 'OBP',
  },
  slugging_percentage: {
    id: 'teamstats.baseball.slugging_percentage',
    defaultMessage: 'SLG',
  },
  on_base_plus_slugging: {
    id: 'teamstats.baseball.on_base_plus_slugging',
    defaultMessage: 'OPS',
  },
  home_runs: {
    id: 'teamstats.baseball.home_runs',
    defaultMessage: 'HR',
  },
  stolen_bases: {
    id: 'teamstats.baseball.stolen_bases',
    defaultMessage: 'SB',
  },
  // pitching
  earned_run_average: {
    id: 'teamstats.baseball.earned_run_average',
    defaultMessage: 'ERA',
  },
  walks_plus_hits_per_inning_pitched: {
    id: 'teamstats.baseball.walks_plus_hits_per_inning_pitched',
    defaultMessage: 'WHIP',
  },
  strikeouts_per_9_innings_pitched: {
    id: 'teamstats.baseball.strikeouts_per_9_innings_pitched',
    defaultMessage: 'K/9',
  },
  fielding_percentage: {
    id: 'teamstats.baseball.fielding_percentage',
    defaultMessage: 'FLD%',
  },
  batting_average_against: {
    id: 'teamstats.baseball.batting_average_against',
    defaultMessage: 'BAA',
  },
});

const BASKETBALL = defineMessages({
  // pregame
  pace: {
    id: 'teamstats.basketball.pace',
    defaultMessage: 'Pace',
  },
  field_goals_percentage: {
    id: 'teamstats.basketball.field_goals_percentage',
    defaultMessage: 'FG (%)',
  },
  three_point_field_goals_made_average: {
    id: 'teamstats.basketball.three_point_field_goals_made_average',
    defaultMessage: '3PT FG',
  },
  three_point_field_goals_percentage: {
    id: 'teamstats.basketball.three_point_field_goals_percentage',
    defaultMessage: '3PT FG (%)',
  },
  free_throws_percentage: {
    id: 'teamstats.basketball.free_throws_percentage',
    defaultMessage: 'FT (%)',
  },
  rebounds_total_average: {
    id: 'teamstats.basketball.rebounds_total_average',
    defaultMessage: 'Rebounds',
  },
  rebounds_offensive_average: {
    id: 'teamstats.basketball.rebounds_offensive_average',
    defaultMessage: 'Offensive Rebounds',
  },
  assists_average: {
    id: 'teamstats.basketball.assists_average',
    defaultMessage: 'Assists',
  },
  assist_rate: {
    id: 'teamstats.basketball.assist_rate',
    defaultMessage: 'Assist (%)',
  },
  steals_average: {
    id: 'teamstats.basketball.steals_average',
    defaultMessage: 'Steals',
  },
  turnovers_average: {
    id: 'teamstats.basketball.turnovers_average',
    defaultMessage: 'Turnovers',
  },
  true_shooting_percentage: {
    id: 'teamstats.basketball.true_shooting_percentage',
    defaultMessage: 'True Shooting (%)',
  },
  effective_field_goal_percentage: {
    id: 'teamstats.basketball.effective_field_goal_percentage',
    defaultMessage: 'Effective Field Goal (%)',
  },
  offensive_rating: {
    id: 'teamstats.basketball.offensive_rating',
    defaultMessage: 'Offensive Rating',
  },
  defensive_rating: {
    id: 'teamstats.basketball.defensive_rating',
    defaultMessage: 'Defensive Rating',
  },
  pythagorean_wins: {
    id: 'teamstats.basketball.pythagorean_wins',
    defaultMessage: 'Pythagorean Wins',
  },
  // overview
  rebounds_total: {
    id: 'teamstats.basketball.rebounds_total',
    defaultMessage: 'Rebounds',
  },
  rebounds_offensive: {
    id: 'teamstats.basketball.rebounds_offensive',
    defaultMessage: 'Offensive Rebounds',
  },
  assists: {
    id: 'teamstats.basketball.assists',
    defaultMessage: 'Assists',
  },
  steals: {
    id: 'teamstats.basketball.steals',
    defaultMessage: 'Steals',
  },
  blocked_shots: {
    id: 'teamstats.basketball.blocked_shots',
    defaultMessage: 'Blocks',
  },
  turnovers: {
    id: 'teamstats.basketball.turnovers',
    defaultMessage: 'Turnovers',
  },
  personal_fouls: {
    id: 'teamstats.basketball.personal_fouls',
    defaultMessage: 'Fouls (Pers.)',
  },
});

const HOCKEY = defineMessages({
  // defensive
  goals_allowed_per_game: {
    id: 'teamstats.baseball.goals_allowed_per_game',
    defaultMessage: 'Goals Allowed',
  },
  shots_on_goal_allowed_per_game: {
    id: 'teamstats.baseball.shots_on_goal_allowed_per_game',
    defaultMessage: 'SOG Allowed',
  },
  penalty_minutes_per_game: {
    id: 'teamstats.baseball.penalty_minutes_per_game',
    defaultMessage: 'Penalty Minutes',
  },
  penalty_kill_percentage: {
    id: 'teamstats.baseball.penalty_kill_percentage',
    defaultMessage: 'Penalty Kill (%)',
  },
  // offensive
  goals_per_game: {
    id: 'teamstats.baseball.goals_per_game',
    defaultMessage: 'Goals',
  },
  shots_on_goal_per_game: {
    id: 'teamstats.baseball.shots_on_goal_per_game',
    defaultMessage: 'Shots On Goal',
  },
  power_play_percentage: {
    id: 'teamstats.baseball.power_play_percentage',
    defaultMessage: 'Power Play (%)',
  },
  faceoff_win_percentage: {
    id: 'teamstats.baseball.faceoff_win_percentage',
    defaultMessage: 'Faceoffs (%)',
  },
  team_shooting_percentage: {
    id: 'teamstats.baseball.team_shooting_percentage',
    defaultMessage: 'Shooting (%)',
  },

  // overview
  faceoff_winning_percentage: {
    id: 'teamstats.baseball.faceoff_winning_percentage',
    defaultMessage: 'Faceoffs (%)',
  },
  power_play_opportunities: {
    id: 'teamstats.baseball.power_play_opportunities',
    defaultMessage: 'Power Plays',
  },
  hits: {
    id: 'teamstats.baseball.hits',
    defaultMessage: 'Hits',
  },
  shots: {
    id: 'teamstats.baseball.shots',
    defaultMessage: 'Shots on Goal',
  },
});

const FOOTBALL = defineMessages({
  points_per_game: {
    id: 'teamstats.football.points_per_game',
    defaultMessage: 'Points Per Game',
  },
  yards_per_game: {
    id: 'teamstats.football.yards_per_game',
    defaultMessage: 'Yards Per Game',
  },
  passing_yards_per_game: {
    id: 'teamstats.football.passing_yards_per_game',
    defaultMessage: 'Passing Yards',
  },
  rushing_yards_per_game: {
    id: 'teamstats.football.rushing_yards_per_game',
    defaultMessage: 'Rushing Yards',
  },
  third_down_percentage: {
    id: 'teamstats.football.third_downs_percentage',
    defaultMessage: 'Third Downs Percentage',
  },
  first_downs: {
    id: 'teamstats.football.first_downs',
    defaultMessage: 'First Downs',
  },
  third_downs_efficiency: {
    id: 'teamstats.football.third_downs_efficiency',
    defaultMessage: 'Third Downs Efficiency',
  },
  sack_yards: {
    id: 'teamstats.football.sack_yards',
    defaultMessage: 'Sacks (yards)',
  },
  interceptions_thrown: {
    id: 'teamstats.football.interceptions_thrown',
    defaultMessage: 'Interceptions Thrown',
  },
  punting_average: {
    id: 'teamstats.football.punting_average',
    defaultMessage: 'Punting Average',
  },
  penalty_yards: {
    id: 'teamstats.football.penalty_yards',
    defaultMessage: 'Penalty Yards',
  },
  fumbles_lost: {
    id: 'teamstats.football.fumbles_lost',
    defaultMessage: 'Fumbles Lost',
  },
  possession: {
    id: 'teamstats.football.possession',
    defaultMessage: 'Possession',
  },
});

export default {
  football: FOOTBALL,
  soccer: SOCCER,
  baseball: BASEBALL,
  basketball: BASKETBALL,
  hockey: HOCKEY,
};
